import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { UButtonComponent, UFaIconComponent } from '@updater/angular-common';
import { BackToDashboardButtonComponent as component } from './back-to-dashboard-button.component';

export const BackToDashboardButtonComponent = angular
  .module('components.back-to-dashboard', [
    uiRouter,
    UButtonComponent.name,
    UFaIconComponent.name,
  ])
  .component('uappBackToDashboardButton', component);
